var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"call-to-action"},[_c('h2',[_vm._v("Get Your Corner Today")]),_c('button',{staticClass:"btn btn-white",on:{"click":function($event){return _vm.$bvModal.show('video-modal')}}},[_vm._v("\n    Watch Video\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }